/* Blaettern in der Bestseller-Reihe.

   Ab 990 px liegen acht Karten in einer scrollbaren Spur statt in zwei
   Rasterreihen — das spart 822 px Seitenhoehe. `scroll-snap` allein reicht
   dafuer nicht: mit der Maus gibt es nichts zu ziehen. Dieses Modul haengt
   zwei Knoepfe daran und blendet sie nur ein, wenn die Spur ueberlaeuft.
   Ohne JavaScript bleibt die Spur scrollbar, nur ohne Knoepfe.

   Tastatur braucht keine Sonderbehandlung: die Karten enthalten Links, der
   Browser scrollt sie beim Tabben selbst ins Bild. Die Spur bekommt deshalb
   auch kein tabindex — das waere ein zusaetzlicher, leerer Halt. */
if (!customElements.get('rc-featured-carousel')) {
  class RcFeaturedCarousel extends HTMLElement {
    connectedCallback() {
      this.spur = this.querySelector('[data-track]');
      this.nav = this.querySelector('[data-nav]');
      if (!this.spur || !this.nav) return;

      this.zurueck = this.nav.querySelector('[data-prev]');
      this.vor = this.nav.querySelector('[data-next]');
      if (!this.zurueck || !this.vor) return;

      this.zurueck.addEventListener('click', () => this.blaettern(-1));
      this.vor.addEventListener('click', () => this.blaettern(1));
      this.spur.addEventListener('scroll', () => this.zustand(), { passive: true });

      if ('ResizeObserver' in window) {
        this.beobachter = new ResizeObserver(() => this.zustand());
        this.beobachter.observe(this.spur);
        /* Auch die erste Karte beobachten: beim Wechsel zwischen Spur, Slider
           und Liste aendert sich ihre Breite in jede Richtung, die der Spur
           nicht immer. */
        if (this.spur.firstElementChild) this.beobachter.observe(this.spur.firstElementChild);
      }
      /* Zusaetzlich am Fenster, nicht nur an der Spur: beim Wechsel unter
         700 px wird aus der scrollbaren Spur eine gestapelte Liste. Die Spur
         behaelt dabei ihre Breite, der Beobachter meldet also nichts — die
         Knoepfe waeren stehen geblieben, obwohl es nichts mehr zu blaettern
         gibt. Beim Drehen des Telefons passiert genau das. */
      this.beiGroesse = () => {
        /* Nachlaufend statt vorlaufend: beim Breakpoint-Wechsel greifen erst
           die neuen Regeln, dann stimmen die Masse. Ein Aufruf im selben Frame
           las noch das alte Layout und liess die Knoepfe im falschen Zustand
           stehen. */
        clearTimeout(this.warten);
        this.warten = setTimeout(() => this.zustand(), 120);
      };
      window.addEventListener('resize', this.beiGroesse);
      this.zustand();
    }

    disconnectedCallback() {
      if (this.beobachter) this.beobachter.disconnect();
      if (this.beiGroesse) window.removeEventListener('resize', this.beiGroesse);
      clearTimeout(this.warten);
    }

    /* Eine Seite = so viele Karten, wie ganz ins Fenster passen, mindestens
       eine. Bei vier sichtbaren Karten springt es also um vier weiter. */
    schrittweite() {
      const erste = this.spur.firstElementChild;
      if (!erste) return this.spur.clientWidth;
      const stil = getComputedStyle(this.spur);
      const abstand = parseFloat(stil.columnGap || stil.gap || '0') || 0;
      const zelle = erste.getBoundingClientRect().width + abstand;
      /* Gerundet, nicht abgerundet: die letzte Karte einer Seite traegt keinen
         Abstand hinter sich. Mit `floor(1160 / 296)` kamen drei Karten heraus,
         obwohl vier genau hineinpassen — die Reihe waere schief stehen
         geblieben. Der Abstand kommt deshalb einmal oben drauf. */
      const passen = Math.max(1, Math.round((this.spur.clientWidth + abstand) / zelle));
      return zelle * passen;
    }

    blaettern(richtung) {
      const leise = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.spur.scrollBy({ left: richtung * this.schrittweite(), behavior: leise ? 'auto' : 'smooth' });
    }

    zustand() {
      const rest = this.spur.scrollWidth - this.spur.clientWidth;
      this.nav.hidden = rest <= 2;
      if (this.nav.hidden) return;
      this.zurueck.disabled = this.spur.scrollLeft <= 2;
      this.vor.disabled = this.spur.scrollLeft >= rest - 2;
    }
  }

  customElements.define('rc-featured-carousel', RcFeaturedCarousel);
}
